function loyaltylionModalFriendInit(){
    let allReferralBtns = document.querySelectorAll('.referral-friend-link');
  
    allReferralBtns.forEach(elm => {
      let type = elm.dataset.type, message = elm.dataset.message;
  
      if(message){
        switch (type) {
          case 'twitter':
            elm.href = `https://twitter.com/intent/tweet?text=${message.replace(/{{url}}/g, loyaltylion.customer.referralUrls.twitter)}`;
            break;
          case 'whatsapp':
            elm.href = `https://api.whatsapp.com/send?text=${message.replace(/{{url}}/g, loyaltylion.customer.referralUrls.whatsapp)}`;
            break;
          case 'facebook':
            elm.href = `https://www.facebook.com/sharer/sharer.php?u=${loyaltylion.customer.referralUrls.facebook}`;
            break;
          case 'message':
            elm.href = `sms:?body=${message.replace(/{{url}}/g, loyaltylion.customer.referralUrls.direct)}`;
            break;
          case 'email':
            elm.href = `mailto:?body=${message.replace(/{{url}}/g, loyaltylion.customer.referralUrls.email)}`;
            break;
        
          default:
            elm.href = '#'
            break;
        }
      }else{
        elm.href = '#'
      }
    });
  
    let referralLinkCopy = document.querySelector('.linck-refer .referral-friend-link-copy');
    referralLinkCopy.textContent = loyaltylion.customer.referralUrls.direct;
}

var referModal = document.getElementById("referModalEl");
var referBtn = document.getElementById("referModalBtn");
var referSpan = document.getElementsByClassName("referClose")[0];

if(referModal && referBtn){
  // open the modal when the button is clicked
  referBtn.onclick = function () {
    referModal.classList.add("active");
    loyaltylionModalFriendInit();
  }

  // close the modal when the 'X' is clicked
  referSpan.onclick = function () {
    referModal.classList.remove("active");
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == referModal) {
      referModal.classList.remove("active");
    }
  }
}

let clipLink = document.querySelector('.referral-friend-btn-copi_link');

if(clipLink){
    clipLink.addEventListener('click', function(evt){
        var content = loyaltylion.customer.referralUrls.direct;
        navigator.clipboard.writeText(content);
    });
}
